import { render, staticRenderFns } from "./xmlist.vue?vue&type=template&id=4f126e3b&scoped=true&"
import script from "./xmlist.vue?vue&type=script&lang=js&"
export * from "./xmlist.vue?vue&type=script&lang=js&"
import style0 from "./xmlist.vue?vue&type=style&index=0&id=4f126e3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f126e3b",
  null
  
)

export default component.exports